import 'devextreme/dist/css/dx.material.blue.light.css';
import * as Sentry from '@sentry/react';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import { ToastMessageProvider } from './shared/context/toast-message-context/ToastMessageContext';
import Router from './router';
import './App.scss';
import ToastMessageContainer from './components/ui/toast-message-container';
import AxiosInterceptors from './api/AxiosInterceptors';
import { FilterProvider } from './shared/context/filter-context/FilterContext';
import { ErrorsProvider } from './shared/context/errors-context/ErrorsContext';

const queryClient = new QueryClient({
	defaultOptions: {},
});

const App = Sentry.withProfiler(() => (
	<ErrorsProvider>
		<ToastMessageProvider>
			<AxiosInterceptors>
				<ThemeProvider theme={theme}>
					<CssBaseline />
					<QueryClientProvider client={queryClient}>
						<FilterProvider>
							<Router />
						</FilterProvider>
						<ToastMessageContainer />
					</QueryClientProvider>
				</ThemeProvider>
			</AxiosInterceptors>
		</ToastMessageProvider>
	</ErrorsProvider>
));

export default App;
